/* ==========================================================================
   crocs-footer @ 1.0.0 — acordeones del footer

   Las cuatro columnas de enlaces son <details>: en mobile se abren y cierran
   solas y en desktop tienen que estar siempre abiertas. Forzar el contenido
   visible por CSS no es fiable (los navegadores ocultan el slot del <details>
   cuando no esta abierto), asi que el atributo open se pone y se quita en el
   cruce de breakpoint. Solo se toca al cruzarlo, para no pelear con lo que el
   usuario haya abierto o cerrado.
   ========================================================================== */

(function () {
  'use strict';

  var QUERY = '(min-width: 990px)';

  function sync(mq) {
    var cols = document.querySelectorAll('.crocs-footer__col');
    var i;

    for (i = 0; i < cols.length; i++) {
      if (mq.matches) {
        cols[i].setAttribute('open', '');
      } else {
        cols[i].removeAttribute('open');
      }
    }
  }

  function init() {
    if (!document.querySelector('.crocs-footer__col')) return;

    var mq = window.matchMedia(QUERY);
    sync(mq);

    if (mq.addEventListener) {
      mq.addEventListener('change', function () { sync(mq); });
    } else if (mq.addListener) {
      mq.addListener(function () { sync(mq); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
